export default __webpack_public_path__ + "static/media/yhLogo.26cf3b94.png";